import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { lawValue } from './lawGroups';

/**
 * «Як працює закон» (прототип v4 lawFlow): статті-процедури по черзі — номер кроку в бурштиновому колі, назва, «хто → щодо кого»,
 * між кроками «→»; не вміщається — прокручується вбік.
 */
export function LawFlow({ arts, labels, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const steps = arts.filter((a) => lawValue(a, 'norm') === 'Procedure');
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.flow')}</div>
      <div className="law-flow">
        {steps.map((r, i) => (
          <div key={r.id} className="law-flow__step">
            <button type="button" className="law-flow__card" onClick={() => onOpen('ldart', r)}>
              <span className="law-flow__n">{i + 1}</span>
              <strong>{r.title}</strong>
              <span className="law-flow__who">{labels.option('ldart', 'subject', r.values['subject'])} → {labels.option('ldart', 'counterparty', r.values['counterparty'])}</span>
            </button>
            {i < steps.length - 1 && <span className="law-flow__arrow" aria-hidden>→</span>}
          </div>
        ))}
      </div>
    </section>
  );
}
